var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		34912,
		4912
	],
	"./osmTagToNameMapping-cs.ts": [
		68590,
		8590
	],
	"./osmTagToNameMapping-de.template.ts": [
		74779,
		4779
	],
	"./osmTagToNameMapping-de.ts": [
		37711,
		7711
	],
	"./osmTagToNameMapping-en.ts": [
		295,
		295
	],
	"./osmTagToNameMapping-hu.template.ts": [
		26663,
		9044
	],
	"./osmTagToNameMapping-hu.ts": [
		80891,
		891
	],
	"./osmTagToNameMapping-it.template.ts": [
		83641,
		3641
	],
	"./osmTagToNameMapping-it.ts": [
		4013,
		4013
	],
	"./osmTagToNameMapping-pl.template.ts": [
		4894,
		4894
	],
	"./osmTagToNameMapping-pl.ts": [
		32140,
		2140
	],
	"./osmTagToNameMapping-sk.template.ts": [
		44152,
		4152
	],
	"./osmTagToNameMapping-sk.ts": [
		53766,
		3766
	],
	"./osmTagToNameMapping-xx.template.ts": [
		24810,
		4810
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;